<template>
  <div>
    <v-btn
      v-if="!formState"
      color="primary"
      class="mb-10"
      @click="formState = 'scanning'"
    >
      <v-icon class="mr-2">{{ mdiQrcodeScan }}</v-icon>
      {{ $$t('scan') }}
    </v-btn>
    <qrcode-stream v-if="formState === 'scanning'" @decode="onDecode"></qrcode-stream>
    <v-progress-circular indeterminate color="primary" v-if="isLoading"></v-progress-circular>
    <v-card v-if="formState === 'scanned' && client">
      <v-card-title>
        {{ client.initials }} {{ client.surname }}
        <span class="float-right ml-2">({{ client.contractCode }})</span>
      </v-card-title>
      <v-card-text>
        <v-list subheader>
          <div v-for="familyMember in client.familyMembers" :key="familyMember.id">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ familyMember.name }} {{ familyMember.surname }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            </div>
        </v-list>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
    <!-- <hr />
    <v-btn color="success" @click="onDecode('1594')">hand</v-btn> -->
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import { mdiQrcodeScan } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'Scanner',
  module: 'Membership',
  components: {
    QrcodeStream,
  },
  mixins: [loading],
  data() {
    return {
      mdiQrcodeScan,
      client: undefined,
      formState: undefined,
    };
  },
  methods: {
    async onDecode(decodedString) {
      this.contractCode = decodedString;
      this.formState = 'scanned';
      try {
        this.isLoading = true;
        const result = await this.$http.get(`api/search/user/${decodedString}`);
        this.client = result.data;
        this.$emit('userId', this.client.userId);
        this.$emit('name', `${this.client.initials} ${this.client.surname}`);
      } catch (error) {
        this.$root.$emit('network.error');
        this.formState = undefined;
        this.$log.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

};
</script>
